import React from "react";
import styled from "styled-components";
import { TfiInfoAlt } from "react-icons/tfi";
import { BO1T8Map } from "../../../utils/constants";

const DraftSection = ({
  isPublic,
  gamesFormat,
  mapDraft,
  civDraft,
  playerA,
  playerB,
  onChangeMapDraft,
  onChangeCivDraft,
}) => {
  const isBO1 = gamesFormat === "BO1";

  if (!isPublic) {
    return (
      <SectionCard>
        <SectionHeader>ANTES DE EMPEZAR</SectionHeader>
        {!isBO1 ? (
          <DraftRow>
            <DraftIcon
              src="https://www.aoe2cm.net/images/aoe2cm2.png"
              alt="draft"
            />
            <DraftLabel>Draft mapas:</DraftLabel>
            <DraftInput
              type="text"
              placeholder="link draft mapas"
              value={mapDraft}
              onChange={(event) => onChangeMapDraft(event.target.value)}
            />
          </DraftRow>
        ) : null}
        {!isBO1 ? (
          <DraftRow>
            <DraftIcon
              src="https://www.aoe2cm.net/images/aoe2cm2.png"
              alt="draft"
            />
            <DraftLabel>Draft civis:</DraftLabel>
            <DraftInput
              type="text"
              placeholder="link draft civis"
              value={civDraft}
              onChange={(event) => onChangeCivDraft(event.target.value)}
            />
          </DraftRow>
        ) : null}
        {!isBO1 ? (
          <InfoNote>
            <TfiInfoAlt />
            <div>
              <p>Antes de comenzar a jugar debéis:</p>
              <p>
                {" "}
                - 1º draft de mapas (Anfitrión: {playerA?.username} | Invitado:{" "}
                {playerB?.username})
              </p>
              <p>
                {" "}
                - 2º draft de civis (Anfitrión: {playerA?.username} | Invitado:{" "}
                {playerB?.username})
              </p>
            </div>
          </InfoNote>
        ) : (
          <InfoNote>
            <p>
              No hay draft de mapas. Se juega el mapa decidido por la
              organización: {BO1T8Map}
            </p>
            <p>
              Tampoco hay draft de civis. Se juega la civilización que queráis
              (free pick incluido "random" y "espejo")
            </p>
          </InfoNote>
        )}
      </SectionCard>
    );
  }

  return (
    <SectionCard>
      <SectionHeader>DRAFTS</SectionHeader>
      <DraftRow>
        <DraftIcon
          src="https://www.aoe2cm.net/images/aoe2cm2.png"
          alt="draft"
        />
        {mapDraft ? (
          <DraftLink href={mapDraft} target="_blank">
            Draft mapas
          </DraftLink>
        ) : (
          <DraftLabel>Draft de mapas pendiente</DraftLabel>
        )}
      </DraftRow>
      <DraftRow>
        <DraftIcon
          src="https://www.aoe2cm.net/images/aoe2cm2.png"
          alt="draft"
        />
        {civDraft ? (
          <DraftLink href={civDraft} target="_blank">
            Draft civis
          </DraftLink>
        ) : (
          <DraftLabel>Draft de civis pendiente</DraftLabel>
        )}
      </DraftRow>
    </SectionCard>
  );
};

const SectionCard = styled.div`
  background: var(--v-surface);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 1.25rem;
`;

const SectionHeader = styled.h4`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--v-mint);
  margin: 0 0 0.75rem;
`;

const DraftRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`;

const DraftIcon = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  object-fit: contain;
  flex-shrink: 0;
`;

const DraftLabel = styled.span`
  font-family: var(--v-font-body);
  font-size: 13px;
  color: var(--v-fg);
  white-space: nowrap;
`;

const DraftInput = styled.input`
  flex: 1;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 0.4rem 0.6rem;
  font-family: var(--v-font-mono);
  font-size: 11px;
  color: var(--v-fg);
  outline: none;

  &:focus {
    border-color: var(--v-mint);
  }

  &::placeholder {
    color: var(--v-fg-muted);
    opacity: 0.5;
  }
`;

const DraftLink = styled.a`
  font-family: var(--v-font-mono);
  font-size: 11px;
  font-weight: 600;
  color: var(--v-mint);
  text-decoration: none;

  &:hover {
    color: var(--v-hover);
  }
`;

const InfoNote = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.75rem;
  font-family: var(--v-font-body);
  font-size: 12px;
  font-style: italic;
  color: var(--v-fg-muted);
  line-height: 1.4;

  p {
    margin: 0;
  }
`;

export default DraftSection;
